import type { MessageGeneration } from '../types/chat';
import { clearSkillStreamStatusFields } from './parse-message-skill-events';
import { clearSubagentStreamStatusFields } from './parse-message-subagent-runs';
import { clearToolCallStreamStatusFields } from './parse-message-tool-calls';
import { clearStreamStatusEntryFields } from './stream-status-entries';

/**
 * Clears transient tool/skill/subagent streaming UI fields once assistant text is available.
 * Keeps streamStatusEntries so the post-response Steps dropdown can reuse them.
 */
export function clearStreamingStatusFields<T extends MessageGeneration>(generation: T): T {
  const { pausedForAuth: _paused, ...rest } = generation;
  return clearSubagentStreamStatusFields(
    clearSkillStreamStatusFields(clearToolCallStreamStatusFields(rest as T))
  );
}
